'usr strict';

import controller from './usuario.controller';
import template from './usuario.html';

const UsuarioComponent = {
  bindings: {},
  controller,
  template
};

export default UsuarioComponent;



// WEBPACK FOOTER //
// ./src/app/components/admin/usuarios/usuario/usuario.component.js